var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.path == `/provider-advisor/providers/${_vm.routeParams}/rates/create-rate`)?_c('CreateRates'):_vm._e(),(_vm.path == `/provider-advisor/providers/${_vm.routeParams}/rates`)?_c('Rates'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }